// extracted by mini-css-extract-plugin
export default {"flex-space":"CustomerReport_flex-space__lQt7L"};